{
  "PoundUkStd": "£ - British Pound Sterling",
  "PoundUkIso": "GBP - British Pound Sterling",
  "DollarUsaStd": "$ - United States Dollar",
  "DollarUsaOther": "US$ - United States Dollar",
  "DollarUsaIso": "USD - United States Dollar",
  "DollarCanadaEnglishStd": "$ - Canadian Dollar (English)",
  "DollarCanadaEnglishOther": "C$ - Canadian Dollar (English)",
  "DollarCanadaFrenchStd": "$ - Canadian Dollar (French)",
  "DollarCanadaFrenchOther": "C$ - Canadian Dollar (French)",
  "DollarCanadaIso": "CAD - Canadian Dollar",
  "DollarAustraliaStd": "$ - Australian Dollar",
  "DollarAustraliaOther": "A$ - Australian Dollar",
  "DollarAustraliaIso": "AUD - Australian Dollar",
  "DollarNewzealandStd": "$ - New Zealand Dollar",
  "DollarNewzealandOther": "NZ$ - New Zealand Dollar",
  "DollarNewzealandIso": "NZD - New Zealand Dollar",
  "DollarSingaporeStd": "$ - Singapore Dollar",
  "DollarSingaporeOther": "S$ - Singapore Dollar",
  "DollarSingaporeIso": "SGD - Singapore Dollar",
  "DollarHongkongStd": "$ - Hong Kong Dollar",
  "DollarHongkongOther": "HK$ - Hong Kong Dollar",
  "DollarHongkongIso": "HKD - Hong Kong Dollar",
  "EuroGeneralStd": "€ - Euro (General)",
  "EuroFrenchStd": "€ - Euro (French)",
  "EuroGermanStd": "€ - Euro (German)",
  "EuroItalianStd": "€ - Euro (Italian)",
  "EuroIso": "EUR - Euro",
  "YenJapanStd": "¥ - Japanese Yen",
  "YenJapanIso": "JPY - Japanese Yen",
  "FrancSchwitzerlandFrenchStd": "fr. - Swiss Franc (French)",
  "FrancSchwitzerlandGermanStd": "Fr. - Swiss Franc (German)",
  "FrancSchwitzerlandItalianStd": "fr. - Swiss Franc (Italian)",
  "FrancSchwitzerlandIso": "CHF - Swiss Franc",
  "YuanChinaStd": "¥ - Chinese Yuan Renminbi",
  "YuanChinaIso": "CNY - Chinese Yuan Renminbi",
  "PesoMexicoStd": "$ - Mexican Peso",
  "PesoMexicoIso": "MXN - Mexican Peso",
  "KronaSwedenStd": "kr - Swedish Krona",
  "KronaSwedenIso": "SEK - Swedish Krona",
  "KroneNorwayStd": "kr - Norwegian Krone",
  "KroneNorwayIso": "NOK - Norwegian Krone",
  "WonSouthkoreaStd": "₩ - South Korean Won",
  "WonSouthkoreaIso": "KRW - South Korean Won",
  "LiraTurkeyStd": "₺ - Turkish Lira",
  "LiraTurkeyIso": "TRY - Turkish Lira",
  "RupeeIndiaStd": "₹ - Indian Rupee",
  "RupeeIndiaIso": "INR - Indian Rupee",
  "RupleRussiaStd": "₽ - Russian Ruble",
  "RupleRussiaIso": "RUB - Russian Ruble",
  "RealBrazilStd": "R$ - Brazilian Real",
  "RealBrazilIso": "BRL - Brazilian Real",
  "RandSouthafricaStd": "R - South African Rand",
  "RandSouthafricaIso": "ZAR - South African Rand",
  "NAME": "Currency"
}